<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label && showLabel) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    [multiple]="multiple"
    [placeholder]="placeholder"
    [formControl]="control"
    [matTooltip]="(multiple && (control.value?.length || 0) > 1) ? getTooltipString() : ''"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="toolTipPosition"
    [required]="required"
    (closed)="onSelectionChange()">
    @if (multiple) {
      <mat-select-trigger>
        @if ((control.value?.length || 0) === 1) {
          <span>
            {{control.value?.[0].Name || control.value?.[0]}}
          </span>
        }
        @if ((control.value?.length || 0) > 1 && (control.value?.length - 1) == options.length) {
          <span>
            All
          </span>
        }
        @if ((control.value?.length || 0) > 1 && (control.value?.length - 1) < options.length) {
          <span>
            Multiple
          </span>
        }
        @if ((control.value?.length || 0) > 1) {
          <span>
            ({{getSelectCount()}})
          </span>
        }
      </mat-select-trigger>
    }

    @if (selectAllEnabled) {
      <mat-option
        #allItem
        [value]="allOption"
      (click)="onToggleItem(allItem)">All</mat-option>
    }

    @for (option of options; track option) {
      <mat-option
        #item
        [value]="option"
        (click)="onToggleItem(item)">
        {{option.DisplayName}}
      </mat-option>
    }
  </mat-select>
  @if (control.hasError('required')) {
    <mat-error>
      {{label ?? 'Field'}} <strong>required</strong>
    </mat-error>
  }
</mat-form-field>
